<div class="no-data">
    @if(!noData) {
        @if (showImage) {
            <figure>
                <img src="../../../assets/img/no-data.gif" alt="" />
            </figure>
        }
        <h3 [innerHTML]="heading"></h3>
        <p [innerHTML]="description"></p>
    } @else {
        <h3>"{{heading1}}"</h3>
        <p>Start by clicking <a class="link" data-target="createModal" data-toggle="modal" (click)="createNew()">Create New</a> to add {{title}}.</p>
    }
</div>